import { useSelector } from 'react-redux';

import type { CoreStoreState } from './selector.type';

/** Use CoreStore Selector. */
export const useCoreStoreSelector = useSelector.withTypes<CoreStoreState>();
